import { createQueryKeys } from '@lukemorales/query-key-factory';

/**
 * params for a majority of campaign calls
 */
type CoreParams = {
	affiliateId: string;
	clientId: string;
	searchText: string;
	clientSearch: string;
};

/**
 * params for general campaign calls
 */
type SimpleParams = {
	clientId: string;
};

type MarketSegment = {
	id: number;
	segmentName: string;
	segmentType: string;
}

/**
 * Client/Business profile data structure
 */
export interface ClientBusiness {
	id: number;
	clientId: number;
	name: string;
	createdAt: string;
	updatedAt: string;
	logo: string | null;
	emailAddress: string | null;
	businessAddress: string;
	termsAndConditionsURL: string;
	privacyPolicyURL: string;
	maskInfo: boolean;
	processorId: number;
	isConfigured: boolean;
	currency: string;
	language: string;
	eCommerceSolution: string;
	automaticRewardProcessing: boolean;
	webstoreURL: string;
	supportEmail: string;
	allowedDomains: string | null;
	marketVertical: MarketSegment;
	marketSubCategory: MarketSegment;
}

export interface ClientBusinessReturn extends ClientBusiness {

}

/**
 * reuable query keys for Converions for use with useQuery or useMutation
 */
export const queryKeys = createQueryKeys('business', {
	getBusiness: ({ clientId }: SimpleParams) => ({
		clientId,
	}),
	updateBusiness: (business: Partial<ClientBusiness>) => (business)
});
